import type { StrictSubscriptionOptions } from 'owa-apollo-types';
import type {
    Observable,
    FetchResult,
    OperationVariables,
    SubscriptionOptions,
    TypedDocumentNode,
} from '@apollo/client';
import { getApolloClientInternal } from './apolloClient';

export function strictSubscribe<
    TSchemaVars extends OperationVariables,
    TActualVars extends import('owa-graph-schema').Exact<TSchemaVars>,
    TData
>(
    query: TypedDocumentNode<TData, TSchemaVars>,
    options: StrictSubscriptionOptions<TActualVars, TData> = {}
): Observable<FetchResult<TData>> {
    // Apollo doesn't have a way to set default options for subscriptions so we set the default here
    options.fetchPolicy ||= 'no-cache';
    const client = getApolloClientInternal();
    return client.subscribe({
        ...(options as unknown as SubscriptionOptions<TSchemaVars, TData>),
        query,
    });
}
